import {Store} from "pullstate";
import {useCallback, useEffect} from "react";
import {homeCoursesAPI} from "../../api/homeCourses";
import {AppStore} from "../../useAppPullState";
import {getUserParamsSelector} from "../actions/syncUserBookings";
import {toast} from "react-toastify";


export const SelectHomeCourseModalStore = new Store({
    visible: false,
    closable: true,
    accepted: false,
    loadings: {
        setHomeCourse: false,
        memberHomeCourse: true,
        rules: true,
    },
    homeCourse: null,
    selectedHomeCourse: null,
    locations: [],
    rules: null,
});


export const setHomeCourse = (value) => {
    SelectHomeCourseModalStore.update(s => {
        s.selectedHomeCourse = value;
    })
}


export const acceptRules = (value) => {
    SelectHomeCourseModalStore.update(s => {
        s.accepted = value;
    })
}


export const useLoadRules = () => {
    const {memberId, password, adminId} = getUserParamsSelector(AppStore.getRawState())
    useEffect(() => {
        if(!memberId && !adminId && !password) return;
        // console.log("[[SelectHomeCourseModalStore]] useLoadRules");
        // load rules
        homeCoursesAPI.getRules({memberId, password, adminId}).then((result) => {
            // console.log("[[SelectHomeCourseModalStore]] rules", result);
            SelectHomeCourseModalStore.update(s => {
                s.rules = result?.rules;
                s.homeCourse = result?.homeCourse;
                s.closable = !!result?.homeCourse?.courseId;
                s.visible = !result?.homeCourse?.courseId;
                s.locations = Object.entries(result?.locations).map(([id, loc]) => ({id, ...loc}));
                s.loadings.rules = false;
            })
        })
    }, [memberId, password, adminId])
}


export const useHomeCourseModalVisible = () => {
    return SelectHomeCourseModalStore.useState(s => s.visible)
}

export const useSetHomeCourse = () => {
    const {memberId, password, adminId} = getUserParamsSelector(AppStore.getRawState())
    return useCallback(async (courseId) => {
        SelectHomeCourseModalStore.update(s => {
            s.loadings.setHomeCourse = true;
        })

        await homeCoursesAPI.setHomeCourse({memberId, adminId, password, courseId}, (res) => {
            SelectHomeCourseModalStore.update(s => {
                s.loadings.setHomeCourse = false;
            })
        })

        toast.dismiss('setHomeCourse')
        toast.success('Oma pelioikeus kenttä lisätty.');
        SelectHomeCourseModalStore.update(s => {
            s.homeCourse = {
                courseId
            }
        });
    }, [memberId, password, adminId])

}

export const openSelectHomeCourseModal = () => {
    SelectHomeCourseModalStore.update(s => {
        s.visible = true;
    });
}
